import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ImageProcessingToolKey,
  reportImageProcessingToolVisit,
} from '../services/imageProcessingToolVisits';

const TOOL_KEY_BY_ROUTE: Readonly<Record<string, ImageProcessingToolKey>> = {
  '/image-compress': 'compress',
  '/format-convert': 'format-convert',
  '/video-to-gif': 'video-to-gif',
  '/video-compressor': 'video-compressor',
  '/image-watermark': 'watermark',
};

const normalizePathname = (pathname: string): string => {
  if (pathname === '/') {
    return pathname;
  }
  return pathname.replace(/\/+$/, '');
};

const ToolVisitTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const toolKey = TOOL_KEY_BY_ROUTE[normalizePathname(pathname)];
    if (toolKey) {
      reportImageProcessingToolVisit(toolKey);
    }
  }, [pathname]);

  return null;
};

export default ToolVisitTracker;
